var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "journey-step px-5 py-2"
  }, [_c('div', {
    staticClass: "d-flex flex-row align-center"
  }, [_c('div', {
    staticClass: "flex-grow-1",
    domProps: {
      "innerHTML": _vm._s(_vm.getStepHTML(_vm.getJourney[_vm.stepIndex].name[_vm.defaultLanguage] || _vm.getJourney[_vm.stepIndex].name[_vm.defaultLanguage] || _vm.$t('journeystep_edit_me')))
    }
  }), _c('div', [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.openStepEdit
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "accent"
    }
  }, [_vm._v("mdi-cog-outline")])], 1), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.deleteStep
    }
  }, [_c('v-icon', [_vm._v("$remove")])], 1)], 1)]), _c('div', {
    staticClass: "d-flex flex-row align-center"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('v-icon', [_vm._v("mdi-map-marker")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getStepHTML(_vm.getJourney[_vm.stepIndex].location[_vm.defaultLanguage] || _vm.$t('journeystep_step_location')))
    }
  })], 1), _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getStepHTML(_vm.getJourney[_vm.stepIndex].date || _vm.$t('journeystep_step_date')))
    }
  })])]), _c('v-dialog', {
    attrs: {
      "content-class": "edit-dialog",
      "width": "800",
      "persistent": ""
    },
    model: {
      value: _vm.editModal,
      callback: function callback($$v) {
        _vm.editModal = $$v;
      },
      expression: "editModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('journeystep_configure_step')))]), _c('v-card-text', [_c('div', {
    staticClass: "font-weight-light pb-5",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('journeystep_select_scm_field'))
    }
  }), _c('rich-text-input', {
    attrs: {
      "label": _vm.$t('journeystep_step_description'),
      "mode": "input",
      "content": _vm.stepData.name[_vm.defaultLanguage],
      "json": _vm.jsonObj.name,
      "placeholder": _vm.$t('journeystep_enter_description')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.stepData.name, _vm.defaultLanguage, $event);
      },
      "update:json": function updateJson($event) {
        return _vm.$set(_vm.jsonObj, "name", $event);
      }
    }
  }), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "no-gutter": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('rich-text-input', {
    attrs: {
      "label": _vm.$t('journeystep_step_location_label'),
      "mode": "input",
      "content": _vm.stepData.location[_vm.defaultLanguage],
      "json": _vm.jsonObj.location,
      "placeholder": _vm.$t('journeystep_enter_location')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.stepData.location, _vm.defaultLanguage, $event);
      },
      "update:json": function updateJson($event) {
        return _vm.$set(_vm.jsonObj, "location", $event);
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('rich-text-input', {
    attrs: {
      "label": _vm.$t('journeystep_select_date'),
      "mode": "input",
      "content": _vm.stepData.date,
      "json": _vm.jsonObj.date,
      "placeholder": _vm.$t('journeystep_enter_date')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.stepData, "date", $event);
      },
      "update:json": function updateJson($event) {
        return _vm.$set(_vm.jsonObj, "date", $event);
      }
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex flex-row mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('rich-text-input', {
    attrs: {
      "label": _vm.$t('journeystep_step_latitude'),
      "mode": "input",
      "content": _vm.stepData.lat,
      "json": _vm.jsonObj.lat,
      "placeholder": _vm.$t('journeystep_enter_latitude')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.stepData, "lat", $event);
      },
      "update:json": function updateJson($event) {
        return _vm.$set(_vm.jsonObj, "lat", $event);
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('rich-text-input', {
    attrs: {
      "label": _vm.$t('journeystep_step_longitude'),
      "mode": "input",
      "content": _vm.stepData.lng,
      "json": _vm.jsonObj.lng,
      "placeholder": _vm.$t('journeystep_enter_longitude')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.stepData, "lng", $event);
      },
      "update:json": function updateJson($event) {
        return _vm.$set(_vm.jsonObj, "lng", $event);
      }
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }